import { createContext } from 'react';
import { Message } from './Toast';

export const ToastContext = createContext<{
  messages: Message[];
  removeMessage: (id: string) => void;
  addMessages: (messages: Message[]) => void;
}>({
  messages: [],
  removeMessage: () => {},
  addMessages: () => {},
});
